import { colors, fontFamily } from '@atlaskit/theme';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { messages } from '../messages';

export type UserNavProps = {
  readonly onSwitchAccountClick?: () => void;
  readonly onProfileClick: () => void;
  readonly onLicensesClick: () => void;
  readonly onLogOutClick?: () => void;
};

export function UserNav({
  onSwitchAccountClick,
  onProfileClick,
  onLicensesClick,
  onLogOutClick
}: UserNavProps): JSX.Element {
  if (onLogOutClick) {
    return (
      <Container>
        <Button onClick={() => onSwitchAccountClick && onSwitchAccountClick()}>
          <FormattedMessage {...messages.switchAccount} />
        </Button>
        <Button onClick={() => onProfileClick()}>
          <FormattedMessage {...messages.profile} />
        </Button>
        <Button onClick={() => onLicensesClick()}>
          <FormattedMessage {...messages.licenses} />
        </Button>
        <Button onClick={() => onLogOutClick()}>
          <FormattedMessage {...messages.logOut} />
        </Button>
      </Container>
    );
  } else {
    return (
      <Container>
        <Button onClick={() => onProfileClick()}>
          <FormattedMessage {...messages.profile} />
        </Button>
        <Button onClick={() => onLicensesClick()}>
          <FormattedMessage {...messages.licenses} />
        </Button>
      </Container>
    );
  }
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const Button = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
  outline: inherit;

  color: ${colors.N600};
  text-decoration: none;
  font-family: ${fontFamily};
  font-size: 12px;
  line-height: 21px;
  cursor: pointer;
`;
